module.exports = __webpack_public_path__ + "img/16581293_S.5f696080.png";